<template>
  <div>
    <div class="text-muted bold">
      {{
        $t(
          "events:event.masterlist.RegOtherInfo.ocQuotaType.heading",
          "Tour type:"
        )
      }}
    </div>

    <div
      v-for="entry in entries.filter(x => x.ocQuotaType)"
      :key="entry.id + '-ocQoutaType'"
    >
      <div>
        {{ entry.competition.code }} -
        {{
          $t(
            `events:event.masterlist.RegOtherInfo.ocQuotaType.${entry.ocQuotaType}.text`,
            entry.ocQuotaType
          )
        }}
      </div>
    </div>

    <small class="text-muted">
      {{
        $t(
          "events:event.masterlist.RegOtherInfo.ocQuotaType.hint",
          "To change tour type, contact your NF. Change can be done from FEI entry system."
        )
      }}
    </small>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";

export default defineComponent({
  name: "AppShowQuotaType",
  props: {
    entries: {
      type: Array,
      default: () => []
    }
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        code
      }
    `,
    entryFields: gql`
      fragment _ on Entry {
        ocQuotaType
      }
    `
  }
});
</script>
